import NextLazyImageFuture from "@/components/Core/NextLazyImageFuture";
import { EmblaViewportRefType } from "embla-carousel-react";
import React from "react";
import styled from "styled-components";

interface GalleryThumbnailsProps {
  imageCollection: { filename: string; alt: string }[];
  emblaThumbsRef: EmblaViewportRefType;
  onThumbClick: (index: number) => void;
  selectedIndex: number;
}

const GalleryThumbnailsContainer = styled.div`
  width: 50px;
  @media (max-width: 1000px) {
    width: 100%;
    overscroll-behavior-x: contain;
    position: relative;
    overflow: hidden;
    will-change: transform;
    padding: 0 16px;
  }
`;

const GalleryThumbnailsInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  display: flex;

  @media (max-width: 1000px) {
    flex-direction: row;
  }
`;

const GalleryThumbnailItem = styled.button`
  flex: 0 0 50px;

  aspect-ratio: 1/1;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;
  border: 0px solid transparent;
  outline: none;
  appearance: none;
  cursor: pointer;
  filter: brightness(0.5);
  transition: 0.3s all ease-out;
  border-radius: 4px;
  @media (max-width: 1000px) {
    margin-right: 4px;
    margin-bottom: 0;
  }
  &.active {
    filter: brightness(1);
    transition: 0.3s all ease-out;
  }
`;

export default function GalleryThumbnails({
  imageCollection,
  emblaThumbsRef,
  onThumbClick,
  selectedIndex,
}: GalleryThumbnailsProps) {
  return (
    <GalleryThumbnailsContainer ref={emblaThumbsRef}>
      <GalleryThumbnailsInnerContainer>
        {imageCollection?.map((image, index) => (
          <GalleryThumbnailItem
            key={index}
            onClick={() => onThumbClick(index)}
            className={selectedIndex === index ? "active" : ""}>
            <NextLazyImageFuture fill src={image.filename} alt={image.alt} />
          </GalleryThumbnailItem>
        ))}
      </GalleryThumbnailsInnerContainer>
    </GalleryThumbnailsContainer>
  );
}
